import * as React from 'react';
import {useTranslation} from "react-i18next";
import {data} from "../Store/Data";

interface IProps {
	category: string;
}

const TopPageSubtitle = ({category}: IProps) => {
	const {t} = useTranslation();
	const ab1 = data("ab1").asBool();
	const bonus = data("bonus").asString();

	if (category === "videos") {
		return <p className="subtitle light-grayed-text text-align-center">
			{t("Tausende von exklusiven Videos warten auf dich!")}
		</p>
	}

	if (category === "chatting") {
		return <p className="subtitle light-grayed-text text-align-center">
			{t("Führe intime 1:1 Gespräche und baue echte Verbindungen auf!")}
		</p>
	}

	if (bonus !== "") {
		return <p className="subtitle light-grayed-text text-align-center">
			{t(
				"Melde dich an, erhalte bis zu 250€ in VX-Coins auf deine erste Aufladung"
			)}
		</p>
	}

	if (ab1) {
		return <p className="subtitle light-grayed-text text-align-center">
			{t(
				"Melde dich an, erhalte 100% auf deine erste Einzahlung und sieh deine Models live in Aktion"
			)}
		</p>
	}

	return <p className="subtitle light-grayed-text text-align-center">
		{t("Melde dich an, erhalte 40€ in VX-Coins und sieh deine Models live in Aktion")}
	</p>
};

export default TopPageSubtitle
